/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SizeInputs */

const en_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const es_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño`)
};

const fr_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const de_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

const ja_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ`)
};

const zh_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大小`)
};

const ar_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحجم`)
};

const id_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran`)
};

const it_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione`)
};

const ru_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер`)
};

const pt_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho`)
};

const ko_size = /** @type {(inputs: SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const size = /** @type {((inputs?: SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_size(inputs)
	if (locale === "es") return es_size(inputs)
	if (locale === "fr") return fr_size(inputs)
	if (locale === "de") return de_size(inputs)
	if (locale === "ja") return ja_size(inputs)
	if (locale === "zh") return zh_size(inputs)
	if (locale === "ar") return ar_size(inputs)
	if (locale === "id") return id_size(inputs)
	if (locale === "it") return it_size(inputs)
	if (locale === "ru") return ru_size(inputs)
	if (locale === "pt") return pt_size(inputs)
	return ko_size(inputs)
});